'use client';

import React from 'react';

interface FormFieldProps {
  label: string;
  children: React.ReactNode;
  description?: string;
  className?: string;
}

export const FormField: React.FC<FormFieldProps> = ({
  label,
  children,
  description,
  className = '',
}) => {
  return (
    <div className={className}>
      <label className="block text-[10px] font-semibold uppercase tracking-widest text-black mb-2">
        {label}
      </label>
      {children}
      {description && (
        <p className="mt-1 text-xs text-gray-400">
          {description}
        </p>
      )}
    </div>
  );
};

